
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[urlname]",
      function () {
        return require("private-next-pages/user/[urlname]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[urlname]"])
      });
    }
  